import { Injectable } from '@angular/core';

export const getWindow = (): Window => {
  return window;
};

@Injectable({ providedIn: 'root' })
export class WindowRefService {
  get window(): Window {
    return getWindow();
  }
}
